import * as React from "react";
import { cx } from "../util.js";

export interface StatCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Uppercase label, e.g. "Total words". */
  label: React.ReactNode;
  /** Big value, e.g. "643" or "1 day". */
  value: React.ReactNode;
  /** Small sub-text under the value. */
  sub?: React.ReactNode;
  /** Optional icon/emoji shown in a tinted square. */
  icon?: React.ReactNode;
}
/** Dashboard statistic card (words, scenes, streak). */
export function StatCard({ label, value, sub, icon, className, ...rest }: StatCardProps) {
  return (
    <div className={cx("ip-stat", className)} {...rest}>
      <div>
        <div className="ip-stat-k">{label}</div>
        <div className="ip-stat-v">{value}</div>
        {sub && <div className="ip-stat-sub">{sub}</div>}
      </div>
      {icon && <div className="ip-stat-icon" aria-hidden>{icon}</div>}
    </div>
  );
}
